import { RankTier } from '@montugroup/pms-api-contracts';
import { Typography, useTheme } from '@mui/material';

import { usePrescriptionItemFeatureFlags } from '@/components/Patient/components/PrescriptionItemEditor/hooks';

export interface TierLabelProps {
  label: string;
  tier?: RankTier;
  role?: React.AriaRole;
}

const tierToPalette = (tier: RankTier) => {
  switch (tier) {
    case RankTier.Second:
      return 'error';
    case RankTier.First:
    default:
      return 'success';
  }
};

/**
 * Typically used for displaying tags. colour coded label based on a set of pre-defined tiers
 *
 * @param label - text to display on the tag
 * @param tier - tier level i.e #1, #2...
 * @param role - aria-role for the component
 *
 * @returns JSXElement
 *
 */
const TierLabel = ({ label, tier = RankTier.First, role }: TierLabelProps) => {
  const { enablePricingExperiment, recommendedMedicationsCount } = usePrescriptionItemFeatureFlags();
  const withinTopN = Array.from({ length: recommendedMedicationsCount }, (_, i) => `#${i + 1} `).some((n) =>
    label.startsWith(n),
  );
  const palette = enablePricingExperiment && withinTopN ? tierToPalette(RankTier.First) : tierToPalette(tier);

  const theme = useTheme();
  const colorCode = theme.palette[palette].main;
  return (
    <Typography role={role} color={colorCode} variant="subtitle2">
      {label}
    </Typography>
  );
};

export default TierLabel;
